/** @license ISC License (c) copyright 2018 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var isFunction = require('./isFunction')

var isTypeRepOf = function (x, y) { return isFunction(y)
    && (x === y || x.name === y.name); }

module.exports = isTypeRepOf
